// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"98":"500c3ac7","101":"ec321d4b","133":"527aa496","478":"ca63e5b2","942":"0f96e309","948":"f836a417"}[chunkId] + ".chunk.js";
};